
import Index from '~/pages/company-pages/_company/index'
export default Index
